import {Action, ActionReducerMap} from '@ngrx/store';
import * as actionsUi from './veranstaltung-main.actions.ui';

export interface ModuleState {
    page: PageState;
}

export const reducers: ActionReducerMap<ModuleState> = {
    page: pageReducer
};


export interface PageState {
    load: boolean;
}

export const initialPageState: PageState = {
    load: false
};


export function pageReducer(state = initialPageState, action: Action): PageState {
    switch (action.type) {
        // APP RESET
        case actionsUi.PAGE_STATE_RESET: {
            return Object.assign({}, state, <PageState>initialPageState, <PageState> {
            });
        }

        default: {
            return state;
        }
    }
}
